<template>
  <default-modal
    :modal-options.sync="modalOptions"
    @cancel="cancel"
  >
    <div class="vote-modal">
      <h5 class="title">
        <p>投票成功！</p>
        <p>即刻参与抽奖，</p>
        <p>赢取跨年好礼！</p>
      </h5>
      <div class="mini-code">
        <img src="@static/rebuild/mini_co.jpg" alt="" class="code-img" />
      </div>
      <div class="co-logo">
        <img src="@static/rebuild/logo_co.png" alt="" class="logo-img" />
      </div>
    </div>
  </default-modal>
</template>

<script>
import DefaultModal from '@components/DefaultModal'

export default {
  name: 'VoteSuccessModal',
  components: {
    DefaultModal
  },
  data () {
    return {
      modalOptions: {
        showTitle: false,
        showCancelBtn: false,
        showConfirmBtn: false
      }
    }
  },
  methods: {
    cancel () {
      this.$emit('hideModal')
    }
  }
}
</script>

<style lang="scss" scoped>
.vote-modal {
  .title {
    font-size: 1.4rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/rebuild/components/VoteSuccessModal.vue